import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { PermissionService } from './permission.service';
import { recursoFromUrl } from './permission.routes';

export const permissionGuard: CanActivateFn = (_route, state) => {
  const perms = inject(PermissionService);
  const router = inject(Router);
  const recurso = recursoFromUrl(state.url);

  if (!recurso) return true;
  if (perms.can(recurso, 'ver')) return true;

  return router.createUrlTree([perms.firstAllowedUrl()]);
};

export const permissionChildGuard: CanActivateChildFn = (child, state) =>
  permissionGuard(child, state);
